// extracted by mini-css-extract-plugin
module.exports = {"root":"ExperimentalTag-root-fad96083e615a47f5ee7e09007009265","button":"ExperimentalTag-button-ef05d0c09df96f55904648d3fe670c92"};